module.exports = {
    FIREBASE_API_KEY: "AIzaSyC_R5mFDaNGS6BYdP536mdTAFUno9gFDl0",
    FIREBASE_AUTH_DOMAIN: "capraise-43d7f.firebaseapp.com",
    FIREBASE_PROJECT_ID: "capraise-43d7f",
    FIREBASE_STORAGE_BUCKET: "capraise-43d7f.appspot.com",
    FIREBASE_MESSAGING_SENDER_ID: "1000835735152",
    FIREBASE_APP_ID: "1:1000835735152:web:d71de51fe19e6fc4df5eb5"
  };
  